import React from 'react';

const PYRAMID_ROWS = [0, 1, 2, 3, 4];

const CoverPyramid = () => (
	<svg className='ArticleCover__pyramid' viewBox='0 0 200 160' aria-hidden='true'>
		{PYRAMID_ROWS.map((row) => {
			const height = 160 / PYRAMID_ROWS.length;
			const top = row * height;
			const halfTop = (row * 100) / PYRAMID_ROWS.length;
			const halfBottom = ((row + 1) * 100) / PYRAMID_ROWS.length;

			return (
				<polygon
					key={row}
					points={`${100 - halfTop},${top} ${100 + halfTop},${top} ${100 + halfBottom},${top + height - 4} ${100 - halfBottom},${top + height - 4}`}
				/>
			);
		})}
	</svg>
);

const ArticleCover = ({ logo, title, subtitle, meta }) => {
	return (
		<div className='ArticleCover'>
			{logo && <img className='ArticleCover__logo' src={logo} alt='' />}

			<div className='ArticleCover__body'>
				<h1 className='ArticleCover__title'>{title}</h1>
				{subtitle && <p className='ArticleCover__subtitle'>{subtitle}</p>}
				<span className='ArticleCover__rule' />
				{!!meta && <p className='ArticleCover__meta'>{meta}</p>}
			</div>

			<CoverPyramid />
		</div>
	);
};

export default ArticleCover;
